import './scss/main.scss';
import AppRoutes from './routes/AppRoutes';

const App = () => <AppRoutes />;

export default App;
